import React, { useState, useEffect } from "react";
import BackToTop from '../components/elements/BackToTop';
import DataBg from "../components/elements/DataBg";
import Breadcrumb from '../components/layout/Breadcrumb';
import SearchPopup from "../components/layout/SearchPopup";
import Sidebar from "../components/layout/Sidebar";
import Footer1 from '../components/layout/footer/Footer1';
import Header1 from "../components/layout/header/Header1";
import { Helmet } from 'react-helmet'; // For setting meta tags like title
import WOW from 'wowjs/dist/wow.min.js'; // Directly import from the minified version
import ChatAssistant from "../Pages/ChatAssistant";
import { FaBed, FaBuilding, FaHandshake, FaRobot, FaUsers } from 'react-icons/fa';
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";


import { Container, Row, Col, Button, Card } from 'react-bootstrap';


export default function Layout({ headerStyle, footerStyle, headTitle, breadcrumbTitle, children, wrapperCls }) {
    const [scroll, setScroll] = useState(0);
    // Mobile Menu
    const [isMobileMenu, setMobileMenu] = useState(false);
    const handleMobileMenu = () => {
        setMobileMenu(!isMobileMenu);
        !isMobileMenu ? document.body.classList.add("mobile-menu-visible") : document.body.classList.remove("mobile-menu-visible");
    };

    const [content, setContent] = useState({
        brandName: 'NewranSS',
        tagline: 'Find Your Perfect Caregiver',
        description: 'Affordable, comfortable, and convenient.',
        exploreButton: 'Explore Rooms',
        features: {
          rooms: 'Comfortable',
          roomsDesc: 'Service from Experts.',
          locations: 'Prime Locations',
          locationsDesc: 'Stay near campus with easy access to amenities.',
          booking: 'Easy Booking',
          bookingDesc: 'Apply online and get instant confirmation.',
        },
        transportation: 'Need more help with Transportation?',
        chatbot: 'Ask Newran for help',
        login: 'Login / Register',
        footer: {
          rights: 'All rights reserved.',
          contact: 'Contact Us',
          privacy: 'Privacy Policy',
        },
      });

    // Popup
    const [isPopup, setPopup] = useState(false);
    const handlePopup = () => setPopup(!isPopup);
    const [showChatbot, setShowChatbot] = useState(false);

    // Sidebar
    const [isSidebar, setSidebar] = useState(false);
    const handleSidebar = () => setSidebar(!isSidebar);
    useEffect(() => {
      if (typeof window !== 'undefined' && window.WOW) {
          const wow = new window.WOW({
              live: false
          });
          wow.init();  // Initialize WOW animations

          document.addEventListener("scroll", () => {
              const scrollCheck = window.scrollY > 100;
              if (scrollCheck !== scroll) {
                  setScroll(scrollCheck);
              }
          });
      }
  }, [scroll]);

    return (
        <>
            <Helmet>
                <title>{headTitle || "NewRan"}</title>
                <meta name="description" content="This is the description for your React app" />
            </Helmet>
            <DataBg />
            <div className={`page-wrapper ${wrapperCls ? wrapperCls : ""}`} id="#top">
                {!headerStyle && <Header1 scroll={scroll} isMobileMenu={isMobileMenu} handleMobileMenu={handleMobileMenu} handlePopup={handlePopup} isSidebar={isSidebar} handleSidebar={handleSidebar} />}
                {headerStyle === 1 && <Header1 scroll={scroll} isMobileMenu={isMobileMenu} handleMobileMenu={handleMobileMenu} handlePopup={handlePopup} isSidebar={isSidebar} handleSidebar={handleSidebar} />}
                {showChatbot && (
                    <ChatAssistant onClose={() => setShowChatbot(false)} />
                )}
 
                <Sidebar isSidebar={isSidebar} handleSidebar={handleSidebar} />
                <SearchPopup isPopup={isPopup} handlePopup={handlePopup} />
                <Container>
                <Row className="justify-content-between">
                    <Col md={7} className="mb-4 mb-md-0">
                    </Col>
                </Row>
                </Container>

            {/* Floating Chatbot Button */}
            <div
                style={{
                    position: 'fixed',
                    bottom: '20px', // Distance from the bottom of the page
                    right: '20px', // Distance from the right edge of the page
                    zIndex: 1000, // Ensure it's on top of other content
                    borderRadius: '25px',
                }}
            >

                {!showChatbot ? (

                        <Button
                            variant="primary"
                            onClick={() => setShowChatbot(true)}
                            className="w-100"
                            style={{
                                background: 'linear-gradient(45deg, #F39733, #00AFEF)',
                                border: 'none',
                                color: 'White',
                                padding: '10px 20px',
                                borderRadius: '25px',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                                cursor: 'pointer',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'scale(1.05)';
                                e.currentTarget.style.boxShadow = '0 6px 8px rgba(0, 0, 0, 0.3)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
                            }}
                        >
                            <IoChatbubbleEllipsesSharp className="me-2" /> {content.chatbot}
                        </Button>
                 ) : <></>}
            </div>
                {breadcrumbTitle && <Breadcrumb breadcrumbTitle={breadcrumbTitle} />}

                {children}

                {!footerStyle && <Footer1 />}
                {footerStyle === 1 && <Footer1 />}
            </div>
            <BackToTop scroll={scroll} />
        </>
    );
}
